import { StationsInputMui } from '@app/components/stations/StationsInputMui';
import { useAppData } from '@app/core/app-data';
import { useToast } from '@app/core/notifications';
import { zodResolver } from '@hookform/resolvers/zod';
import { Box } from '@mui/material';
import { useMemo, useState } from 'react';
import { FormContainer } from 'react-hook-form-mui';
import { useIntl } from 'react-intl';
import { apiClient } from '../../../../../../api';
import { useStations } from '../../../../../../core/stations/hooks/useStations';
import { TemplateForm } from './components/TemplateForm';
import { useAudiogramTemplates } from './hooks/useAudiogramTemplates';
import { getSchema } from './types';

export function AudiogramForm() {
  const { $t } = useIntl();
  const { notifySuccess } = useToast();
  const { refetchStations } = useAppData();
  const stations = useStations();
  const [station, setStation] = useState(stations[0]);
  const { templates } = useAudiogramTemplates(station.id);
  const schema = useMemo(() => getSchema((msg) => $t(msg)), [$t]);

  return (
    <Box>
      <Box mb={3} maxWidth={400}>
        <StationsInputMui
          stations={stations}
          value={station}
          onChange={setStation}
          selectProps={{
            size: 'small',
          }}
        />
      </Box>

      <FormContainer
        key={station.id}
        defaultValues={{
          station,
          templates,
        }}
        resolver={zodResolver(schema)}
        onSuccess={async (data) => {
          await apiClient.fragments.configUpdate(station.id, {
            audiogram: {
              templates: data.templates,
            },
          });

          notifySuccess(
            $t(
              {
                id: 'admin.fragments.configUpdated',
                defaultMessage: 'Fragment configuration for {stationName} updated',
              },
              { stationName: station.name },
            ),
          );

          refetchStations();
        }}
      >
        <TemplateForm />
      </FormContainer>
    </Box>
  );
}
